export function isIOSChrome(userAgent: string, platform: string, maxTouchPoints: number): boolean {
  const ios = /iPhone|iPad|iPod/.test(userAgent) || (platform === 'MacIntel' && maxTouchPoints > 1);
  return ios && /CriOS\//.test(userAgent);
}

export function supportsRoomAR(): boolean {
  // Chrome on iOS implements Quick Look but can report false for rel=ar.
  // Match the known-browser detection used by Google's model-viewer:
  // https://github.com/google/model-viewer/blob/master/packages/model-viewer/src/constants.ts
  if (typeof navigator !== 'undefined' && isIOSChrome(navigator.userAgent, navigator.platform, navigator.maxTouchPoints)) return true;
  try { return document.createElement('a').relList.supports('ar'); }
  catch { return false; }
}

export function arEntry(params: URLSearchParams, nativeSupported: boolean): 'hiro' | 'scan' | 'room' {
  if (!nativeSupported || params.get('mode') === 'hiro' || params.get('cardboard') === '1') return 'hiro';
  return params.get('object') ? 'room' : 'scan';
}

export function scannedRoomUrl(id: string) {
  return '/room/' + encodeURIComponent(id) + '?auto=1';
}
